import axios from "axios";
import { environment } from "environments/environment";
import { onRequestSuccess, onResponseRejected } from "./interceptors";

const drProxServicesInstance = axios.create({
    baseURL: `${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/drproxservices`
});

drProxServicesInstance.interceptors.request.use(onRequestSuccess, undefined);
drProxServicesInstance.interceptors.response.use(undefined, onResponseRejected);

export default drProxServicesInstance;
